<template>
    <v-dialog v-model="visible" width="600">
        <form @submit.prevent="submit">
            <v-card class="d-flex flex-column">
                <FocusLock>
                    <v-card-title class="headline font-weight-bold mb-4">
                        {{ dialogTitle }}
                    </v-card-title>

                    <v-card-text class="pb-0 pt-4 flex-grow-1 d-flex flex-column justify-center">
                        <v-file-upload
                            v-model="selectedFile"
                            :accept="acceptTypes"
                            :show-size="true"
                            clearable
                            :browse-text="$t('lieferanten.dokument.upload.durchsuchen')"
                            :divider-text="$t('lieferanten.dokument.upload.divider')"
                            icon="mdi-upload"
                            :title="uploadTitle"
                            :counter="true"
                            :disabled="false"
                            :loading="false"
                            :multiple="false"
                            class="mb-4"
                            style="max-width: 90%"
                            height="320px"
                        />
                    </v-card-text>

                    <v-card-actions class="ml-4 mt-4">
                        <v-btn type="submit" color="primary" variant="flat" class="modalbutton mb-3" :disabled="!selectedFile">
                            {{ $t('components.dialog.upload') }}
                        </v-btn>
                        <v-btn class="modalbutton mb-3" variant="flat" @click="closeDialog">
                            {{ $t('components.dialog.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </FocusLock>
            </v-card>
        </form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { VFileUpload } from 'vuetify/labs/VFileUpload';

import { NEW_ALERT } from '@/store/modules/headerNotification/actions';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';

const headerNotificationModul = namespace(NAME_HEADERNOTIFICATION);

type FileType = 'XML' | 'PDF';

@Component({
    components: {
        VFileUpload
    }
})
export default class DokumentUploadDialog extends Vue {
    @Prop({ type: String, required: true, validator: (value: string) => ['XML', 'PDF'].includes(value) })
    fileType!: FileType;

    @Prop({ type: Function, required: true })
    onUpload!: (payload: { file: File; tvsLieferantRechnungId: string }) => Promise<void>;

    @headerNotificationModul.Action(NEW_ALERT) alertMessage!: Function;

    visible = false;
    selectedFile: File | null = null;
    tvsLieferantRechnungId: string | null = null;
    fileUploadKey = 0;

    get dialogTitle(): string {
        const key = this.fileType === 'XML' ? 'uploaddialogxmlupload.dialog.title' : 'uploaddialog.pdfupload.dialog.title';
        return this.$t(key);
    }

    get uploadTitle(): string {
        const key = this.fileType === 'XML' ? 'uploaddialog.xmlupload.draganddrop' : 'uploaddialog.pdfupload.draganddrop';
        return this.$t(key);
    }

    get acceptTypes(): string {
        return this.fileType === 'XML' ? '.xml' : '.pdf';
    }

    private closeDialog() {
        this.visible = false;
        this.selectedFile = null;
    }

    private async submit() {
        if (!this.selectedFile || !this.tvsLieferantRechnungId) {
            console.error('Upload failed: Missing required data', {
                hasFile: !!this.selectedFile,
                hasRechnungId: !!this.tvsLieferantRechnungId
            });
            return;
        }

        await this.onUpload({
            file: this.selectedFile,
            tvsLieferantRechnungId: this.tvsLieferantRechnungId
        });

        this.closeDialog();
    }

    public openDialog(tvsLieferantRechnungId: string) {
        this.tvsLieferantRechnungId = tvsLieferantRechnungId;
        this.selectedFile = null;
        this.visible = true;
    }
}
</script>
